import { createSlice } from "@reduxjs/toolkit";

export const profileadditionalinfoSlice = createSlice({
    name: "profileadditionalinfos",
    initialState: {
        data: []
    },
    reducers : {
        setAdditiionalInfo : (state,action) => {
            state.data = action.payload
        }
    }
})

export const {setAdditiionalInfo} = profileadditionalinfoSlice.actions;
export default profileadditionalinfoSlice.reducer;